<template>
  <v-dialog max-width="600px" v-model="outdialog">
    <v-btn flat slot="activator" class="success">Add A Member</v-btn>
    <v-card>
      <v-card-title>
        <h2>Member Registration</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-text-field v-model="email" label="Email"  hint="name@organization.org" prepend-icon="email" :rules="inputRules"></v-text-field>
          <v-text-field v-model="password1" :append-icon="show1 ? 'visibility_off' : 'visibility'"  :type="show1 ? 'text' : 'password'" label="password" hint="At least 8 characters" prepend-icon="lock" :rules="passRules"></v-text-field>
          <v-text-field v-model="password2" :append-icon="show1 ? 'visibility_off' : 'visibility'"  :type="show1 ? 'text' : 'password'" hint="Re-enter password" prepend-icon="lock" :rules="passRules"></v-text-field>
          <v-spacer></v-spacer>

          <v-btn flat @click="submit" class="success mx-0 mt-3" :loading="loading">Register</v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import format from 'date-fns/format'
import {db, auth} from '@/fb'

export default {
  data() {
    return {
      email: '',
      password1: '',
      password2: '',
      menu: false,
      admin: false,
      inputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      passRules: [
        v => !!v || 'This field is required',
        v => v.length >= 8 || 'Minimum length is 8 characters'
      ],
      loading: false,
      outdialog: false
    }
  },
  methods: {
    show1() {
          
    },
    submit() {       
        if(this.$refs.form.validate()) {
          if (this.password1 == this.password2) {
            this.loading = true         
            auth.createUserWithEmailAndPassword(this.email, this.password1)
            .then(function(user) {
              console.log("Account Created Successfully")        
            })
            .catch(function(error) {
              var errorMessage = error.message;
              console.log(errorMessage)
            });       
        } 
      }
    }
  },
  computed: {
    
  }
}
</script>
